import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';

type DetailPanelProps = PropsWithChildren<{
    className: string;
    height?: number;
    width: number;
}>;

export default function DetailPanel(props: DetailPanelProps) {
    const { className, height, width, children } = props;

    const style: React.CSSProperties = { width };
    if (height) {
        style.height = height;
    }

    return (
        <div className={classNames(className, 'detail-panel')} style={style}>
            {children}
        </div>
    );
}
